module.exports = __webpack_public_path__ + "static/media/icon-cooling.56716ec4.svg";